<template>
  <div class="text-center font-weight-bold">
    <b-row class="d-flex justify-content-center">
      <b-col v-if="votesFor" cols="3">
        <b-badge variant="success" class="mx-2"><h4>Pour</h4></b-badge>
        {{ votesFor.length }}
        <b-badge variant="warning">{{ getTotalVotesTantiems(votesFor) }}</b-badge>
      </b-col>
      <b-col v-if="votesAgainst" cols="3">
        <b-badge variant="danger" class="mx-2"><h4>Contre</h4></b-badge>
        {{ votesAgainst.length }}
        <b-badge variant="warning">{{ getTotalVotesTantiems(votesAgainst) }}</b-badge>
      </b-col>
      <b-col v-if="votesAbstain" cols="3">
        <b-badge variant="light" class="mx-2"><h4>Abs.</h4> </b-badge>
        {{ votesAbstain.length }}
        <b-badge variant="warning">{{ getTotalVotesTantiems(votesAbstain) }}</b-badge>
      </b-col>
      <b-col v-if="votesNsp" cols="3">
        <b-badge variant="dark" class="mx-2"><h4>Défaillant</h4></b-badge>
        {{ votesNsp.length }}
        <b-badge variant="warning">{{ getTotalVotesTantiems(votesNsp) }}</b-badge>
      </b-col>
    </b-row>
    <hr />
    <b-row class="d-flex justify-content-center">
      <b-col v-if="votesFor" cols="3">
        <div
          v-for="(event, index) in votesFor"
          :key="'vote-for-' + index"
          class="bg-light my-2 p-2"
        >
          {{
            getPersonNameAndGender({
              personId: event.building_owner_id,
            })
          }}
        </div>
      </b-col>
      <b-col v-if="votesAgainst" cols="3">
        <div
          v-for="(event, index) in votesAgainst"
          :key="'vote-against' + index"
          class="bg-light my-2 p-2"
        >
          {{
            getPersonNameAndGender({
              personId: event.building_owner_id,
            })
          }}
        </div>
      </b-col>
      <b-col v-if="votesAbstain" cols="3">
        <div
          v-for="(event, index) in votesAbstain"
          :key="'vote-abstain-' + index"
          class="bg-light my-2 p-2"
        >
          {{
            getPersonNameAndGender({
              personId: event.building_owner_id,
            })
          }}
        </div>
      </b-col>
      <b-col v-if="votesNsp" cols="3">
        <div
          v-for="(event, index) in votesNsp"
          :key="'vote-NSP-' + index"
          class="bg-light my-2 p-2"
        >
          {{
            getPersonNameAndGender({
              personId: event.building_owner_id,
            })
          }}
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";

export default {
  props: {
    minuteEvent: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    votesNsp() {
      try {
        return this.minuteEvent.votes.votesNsp;
      } catch {
        return null;
      }
    },
    votesFor() {
      try {
        return this.minuteEvent.votes.votesFor;
      } catch {
        return null;
      }
    },
    votesAgainst() {
      try {
        return this.minuteEvent.votes.votesAgainst;
      } catch {
        return null;
      }
    },
    votesAbstain() {
      try {
        return this.minuteEvent.votes.votesAbstain;
      } catch {
        return null;
      }
    },
  },
  methods: {
    getTotalVotesTantiems(votes) {
      try {
        var total = 0;
        for (const vote of votes) {
          total += vote.tantiemes;
        }
        return total;
      } catch {
        return 0;
      }
    },
    getBuildingOwner(buildingOwnerId) {
      return BuildingOwnerORM.getters("getById")(buildingOwnerId);
    },
  },
};
</script>
